import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Apartments.css'; // Reusing Apartments styles for the card layout

import { supabase } from '../supabaseClient';


export default function Villas() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState(null);
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    const fetchVillas = async () => {
      setLoading(true);
      const { data } = await supabase.from('properties').select('*').eq('category', 'villas');
      if (data) setProperties(data);
      setLoading(false);
    };
    fetchVillas();
  }, []);

  return (
    <div className="apartments-page">
      <section className="page-header animate-fade-in-up">
        <div className="container text-center">
          <span className="section-tag" style={{ backgroundColor: 'var(--color-secondary-light)', color: 'var(--color-secondary)' }}>
            Luxury Villas
          </span>
          <h1 className="page-title">Premium Villas</h1>
          <p className="page-subtitle">
            Experience unparalleled luxury and comfort in our meticulously designed villa communities.
          </p>
        </div>
      </section>

      <section className="apartments-grid-section">
        <div className="container">
          <div className="grid-3" style={{ marginTop: '40px', alignItems: 'stretch' }}>
            {loading ? (
              <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px 0' }}>
                <h3 style={{ color: 'var(--text-secondary)' }}>Loading...</h3>
              </div>
            ) : properties.length === 0 ? (
              <div style={{ textAlign: 'center', gridColumn: '1 / -1', padding: '40px 0' }}>
                <h3 style={{ color: 'var(--text-secondary)' }}>No villas found.</h3>
              </div>
            ) : properties.map((project) => (
              <div key={project.id} className="premium-card apartment-card flex-column" onClick={() => setSelectedProject(project)} style={{ cursor: 'pointer' }}>
                <div className="apartment-card-image-container">
                  <img src={project.image_url || project.image} alt={project.title} className="apartment-card-image" />
                  <div className="apartment-card-badges">
                    <span className="approval-badge">✓ {project.approval}</span>
                    <span className="status-badge" style={project.status === "Ready to Move In" ? { backgroundColor: '#ffca28', color: '#333', fontWeight: 'bold', textShadow: 'none' } : {}}>
                      {project.status}
                    </span>
                  </div>
                </div>

                <div className="apartment-card-body">
                  <span className="project-type" style={{ marginBottom: '5px', display: 'block' }}>{project.type}</span>
                  <h2 className="project-title">{project.title}</h2>
                  <p className="project-location">📍 {project.location}</p>

                  <div className="project-specs">
                    <div className="spec-item">
                      <span className="spec-label">Configurations</span>
                      <span className="spec-val">{project.bhk || project.sizes}</span>
                    </div>
                    <div className="spec-item">
                      <span className="spec-label">Area</span>
                      <span className="spec-val">{project.size || project.sizes}</span>
                    </div>
                    <div className="spec-item">
                      <span className="spec-label">Pricing</span>
                      <span className="spec-val highlight-val">{project.price}</span>
                    </div>
                  </div>

                  <div className="apartment-card-footer" style={{ marginTop: 'auto', paddingTop: '15px' }}>
                    <button
                      className="btn btn-primary w-full"
                      style={{ marginBottom: '8px' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedProject(project);
                      }}
                    >
                      View Complete Info
                    </button>
                    <button
                      className="btn btn-secondary w-full"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.localStorage.setItem('enquiry_subject', `Enquiry about ${project.title}`);
                        navigate('/contact');
                      }}
                    >
                      Check Availability & Prices
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedProject && (
        <div className="modal-overlay" onClick={() => setSelectedProject(null)}>
          <div className="modal-content animate-fade-in-up" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedProject(null)}>&times;</button>
            <img src={selectedProject.image_url || selectedProject.image} alt={selectedProject.title} className="modal-image" />
            
            <div className="modal-body">
              <h2 className="modal-title">{selectedProject.title}</h2>
              <p className="modal-tagline">{selectedProject.tagline}</p>
              
              {selectedProject.amenities?.length > 0 && (
                <div className="modal-section">
                  <h3>Amenities & Features</h3>
                  <ul className="grid-list">
                    {selectedProject.amenities.map((feat, i) => <li key={i}>▪ {feat}</li>)}
                  </ul>
                </div>
              )}

              {selectedProject.extended_details?.locationHighlights?.length > 0 && (
                <div className="modal-section">
                  <h3>Location & Connectivity</h3>
                  <ul className="grid-list">
                    {selectedProject.extended_details.locationHighlights.map((loc, i) => <li key={i}>📍 {loc}</li>)}
                  </ul>
                </div>
              )}

              <div className="modal-footer text-center">
                <button
                  className="btn btn-secondary w-full"
                  onClick={() => {
                    window.localStorage.setItem('enquiry_subject', `Enquiry about ${selectedProject.title}`);
                    setSelectedProject(null);
                    navigate('/contact');
                  }}
                >
                  Enquire Now
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
